var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-tabs"},[(_vm.pathsNotEmpty)?_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_vm._l((_vm.visiblePath),function(path){return [_c('el-tab-pane',{key:path.name + path.label,attrs:{"label":path.label}})]})],2):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }